import moment from 'moment'
import { isValidDateObject } from './is-valid-date-object'

/**
 * Check if given date is between start/end of given date range
 *
 * @param {Date} date
 * @param {MixedInterval} interval
 * @returns {boolean}
 */
export function isDateInInterval(date, interval) {
    // treat intervals with moment and date objects separately
    if (interval && moment.isMoment(interval.start) && moment.isMoment(interval.end)) {
        return interval.start.isSameOrBefore(date) && interval.end.isSameOrAfter(date)
    } else if (interval && isValidDateObject(interval.start) && isValidDateObject(interval.end)) {
        return interval.start <= date && interval.end >= date
    }
    return false
}
